module.exports = __webpack_public_path__ + "img/TM.fc2dc6bf.svg";